import { ReactComponent as BackIcon } from "app/assets/images/icons/chevron-left-lg.svg";
import { ReactComponent as ForwardIcon } from "app/assets/images/icons/chevron-right-lg.svg";
import { ReactComponent as DollarSignIconSvg } from "app/assets/images/icons/dollar-solid.svg";
import { PeriodComparisonMessage } from "components/PeriodComparisonMessage";
import { format } from "date-fns";
import { Subheading } from "elements/Subheading";
import { useMonthlyUsageChart } from "pages/UsagePage/compositions/MonthlyUsageChartProvider";
import React from "react";
import { DisplayUnit } from "utils/constants";
import { NZD } from "utils/currency";

import { MonthlyData } from "../MonthlyUsageChart/MonthlyUsageChart.utils";

type MonthDetailProps = {
  monthThisYear: MonthlyData;
  monthLastYear: MonthlyData;
};

/**
 * @description returns a boolean for if the given month has usage and cost data
 */
const monthHasData = (month: MonthlyData): boolean => {
  return month.cost + month.usage !== 0;
};

export const MonthDetail: React.FC<MonthDetailProps> = React.memo(
  ({ monthThisYear, monthLastYear }) => {
    const { setSelectedMonthIndex } = useMonthlyUsageChart();
    const {
      month,
      cost: costThisYear,
      usage: usageThisYear,
      year,
    } = monthThisYear;

    return (
      <div className="usage-detail-container background--grey">
        <div className="usage-detail">
          <h3 className="h4 usage-detail__title">
            {format(new Date(year, Number(month) - 1), "MMM yyyy")}
          </h3>
          <div className="usage-detail__controls">
            <button
              className="chevron-arrows chevron-arrows--alt-background"
              aria-disabled={month === "01"}
              disabled={month === "01"}
              onClick={() => {
                setSelectedMonthIndex((prev) => prev - 1);
              }}
            >
              <BackIcon aria-label="Previous month" />
            </button>
            <button
              className="chevron-arrows chevron-arrows--alt-background"
              aria-disabled={month === "12"}
              disabled={month === "12"}
              onClick={() => {
                setSelectedMonthIndex((prev) => prev + 1);
              }}
            >
              <ForwardIcon aria-label="Next month" />
            </button>
          </div>
        </div>
        {monthHasData(monthThisYear) && (
          <section>
            <Subheading
              title={`Total ${NZD.format(costThisYear)} (${usageThisYear} kWh)`}
              icon={<DollarSignIconSvg />}
            />
            {monthLastYear && (
              <PeriodComparisonMessage
                displayUnit={DisplayUnit.dollar}
                lastPeriod={monthLastYear.cost}
                currentPeriod={costThisYear}
                periodLabel="this time last year"
              />
            )}
          </section>
        )}
      </div>
    );
  },
);
